// extracted by mini-css-extract-plugin
export var articleSection = "blog-article-module--article-section--b10c9";
export var authorId = "blog-article-module--author-id--2e223";
export var centerImage = "blog-article-module--center-image--ea611";
export var headerImage = "blog-article-module--header-image--76058";
export var imageFlex = "blog-article-module--image-flex--4ab6d";
export var mainContent = "blog-article-module--main-content--afdb0";
export var mainTitle = "blog-article-module--main-title--db897";